<template>
    <div class="container">
      <article>
        <p>1、预约号源需支付12元定金 </p>
        <p>2、支付完成后，您将收到预约码，凭预约码去医院就诊 </p>
        <p>3、就诊成功或取消预约，您支付的定金将在7个工作日退还</p>
        <p>4、若您未按预约时间就诊，预约定金将不予退还</p>
        <p>5、如果由于医院排班变动导致您的预约被取消，我们将退还定金，您可重新进行预约</p>
      </article>

      <BtnFixed @click.native="payApply">立即预约</BtnFixed>

    </div>
</template>

<script>
  import { order } from '@/apis'
  import { mapState } from 'vuex'
  import BtnFixed from '@/components/BtnFixed'
  export default {
    data(){
      return {
        reqIsComplete:true,
        orderNo: localStorage.getItem('orderNo'),
      }
    },
    components:{BtnFixed},
    computed:mapState({
      openid: state => state.openid,
      patientId: state => state.patientId,
      patientUUID: state => state.patientUUID,
      // orderNo: state => state.orderNo,
      orderFee: state => state.orderFee,
      orderApplySuccess: state => state.orderApplySuccess,
    }),
    methods:{
      payApply(){
        if(this.openid==null||this.openid==undefined||this.openid=='null' || this.openid=='undefined'||this.openid=='' || !this.openid){
          this.$toast('您还未绑定公众号')
          return
        }
        const query = this.$route.query;
        if(!this.reqIsComplete){
          this.$toast('请勿重复请求！')
          return
        }else{
          if(this.orderApplySuccess){
            this.$toast('订单已生成，请勿重复请求！')
            return
          }else{
            this.axios.post(order.orderCreate,{
              money:this.orderFee,
              openId:this.openid,
              patientId:this.patientId,       //病人id（云鹊）
              patientUUID:this.patientUUID,   //病人id（外部系统）
              scheduleId:query.scheduleId,    //医生排班表ID
              period:query.period             //am/pm 时间段
            }).then((res)=>{
              if(res.status==200&&res.data.code=='000000'){
                this.store.commit('set_order_status',true);
                this.store.commit('get_order_no',res.data.data.orderNo);
                this.$router.push({
                  path:'/payApply',
                  query:{
                    patientId:this.patientId,
                    patientUUID:this.patientUUID,
                    orderNo:res.data.data.orderNo,
                  }
                });

              }else{
                this.$toast(res.data.message)
              }
            }).catch((err)=> {
              console.log(err);
            });
          }
        }

      },
    }
  }
</script>

<style scoped lang="scss">
  .container{
    @include background();
    background:$bgfff;
    article{
      padding:20px 13px;
      p{
        line-height: 22px;
        @include text_font('PingFangSC',14px,normal,#666,left);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/doorHelp/applyTips.vue